import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { BasicButton } from '../../../components/common/Button';
import { InputWord } from '../../../components/common/Input';
import FormHeader from '../../../components/forms/FormHeader';
import { requestSchema, requestType } from '../../../schema/ResetNicknameSchema';
import AuthService from '../../../services/auth.service';

type NicknameRequestFormProps = {
  setPageStep: React.Dispatch<React.SetStateAction<string>>;
};

const NicknameRequestForm = ({ setPageStep }: NicknameRequestFormProps) => {
  const navigate: NavigateFunction = useNavigate();
  const authService = new AuthService();

  const requestMethods = useForm<requestType>({
    resolver: yupResolver(requestSchema),
    mode: 'onSubmit',
    defaultValues: {
      email: '',
    },
  });

  const sendResetNicknameEmail = async ({ email }: requestType) => {
    await authService.resetNickname(email);
    setPageStep(`emailSend`);
  };

  return (
    <>
      <FormHeader
        title={`Réinitialiser votre identifiant`}
        subTitle={`Merci de renseigner l’adresse e-mail associée à votre compte afin que nous puissions vous envoyer un lien de réinitialisation de votre identifiant.`}
      />
      <FormProvider {...requestMethods}>
        <form onSubmit={requestMethods.handleSubmit(sendResetNicknameEmail)}>
          <Controller
            name='email'
            control={requestMethods.control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <>
                <InputWord
                  label='Email'
                  type='text'
                  placeholder='Email'
                  value={value}
                  onChangeValue={onChange}
                  errorMessage={error?.message}
                />
              </>
            )}
          />
          <BasicButton label='Réinitialiser mon identifiant' fullWidth={true} isSubmitButton={true} />
          <div
            onClick={() => navigate(`/login`)}
            className='text-green-secondary mt-3 cursor-pointer text-center font-bold hover:underline'
          >
            Retour à la page de connexion
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default NicknameRequestForm;
